import { render, staticRenderFns } from "./dialog-consent-log.vue?vue&type=template&id=12f2af8e&"
import script from "./dialog-consent-log.vue?vue&type=script&lang=js&"
export * from "./dialog-consent-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports